// extracted by mini-css-extract-plugin
module.exports = {"tab":"_89a0534","icon":"_3f4850c","selectionIndicator":"_5f0403b","tabContent":"_b14fc0f"};